import React from 'react';

interface CodeBadgeProps {
  code: string;
}

const CodeBadge: React.FC<CodeBadgeProps> = ({ code }) => {
  const handleCodeClick = () => {
    window.open(`/squads/code/${code}`, '_blank');
  };

  return (
    <div className="code-badge-prominent" onClick={handleCodeClick}>
      <span className="code-label">Code:</span> <span className="code-value">{code}</span>
    </div>
  );
};

export default CodeBadge;
